const Init = { url: 'https://cognos-api.byteme.indt.org.br/', prefix: '' };
//const Init = {url:'http://localhost:3001/back/',prefix:''}
export default Init;
